import ImageLayer from "../ImageLayer";
import { LayerCustomType } from "../../interfaces";
import { WordSearchLayerProps, WordSearchProps } from "./interfaces";

export default class WordSearchLayer extends ImageLayer {
  protected static customType: LayerCustomType = LayerCustomType.WordSearch;
  protected static defaultTypeProps: Partial<WordSearchProps> = {
    words: "Susan Laura Ryan Paul",
    fontPath: "",
    row: 8,
    column: 8,
    limitWords: 10,
    style: "solid",
    highlightLetterColor: "#000000",
    highlightBackgroundColor: "#FFF59D",
    fillerLetterColor: "#808080",
    outlineWidth: 0.11,
  };

  name: string = "Word search layer";
  wordSearchProps: Partial<WordSearchProps>;

  constructor(options: Partial<WordSearchLayerProps> = {}) {
    const {
      transformSettings = {},
      typeSettings = {},
      ...layerProps
    } = options;
    super();

    this.wordSearchProps = {
      ...WordSearchLayer.defaultTypeProps,
      ...typeSettings,
    };

    this.set(transformSettings);
    this.set(layerProps);
  }

  toObject() {
    const object = super.toObject();
    const wordSearchProps = this.getWordSearchProps() as Partial<WordSearchProps>;
    const {
      words = "",
      fontPath = "",
      row = 0,
      column = 0,
      limitWords = 0,
      style = "solid",
      highlightLetterColor = "",
      highlightBackgroundColor = "",
      fillerLetterColor = "",
      outlineWidth,
      outlineColor,
    } = wordSearchProps;

    return {
      ...object,
      name: "Word search layer",
      typeSettings: {
        words,
        fontPath,
        row,
        column,
        limitWords,
        style,
        highlightLetterColor,
        highlightBackgroundColor,
        fillerLetterColor,
        outlineWidth,
        outlineColor,
      },
    };
  }

  setWordSearchProps(props: Partial<WordSearchProps>) {
    this.wordSearchProps = { ...this.wordSearchProps, ...props };
    this.rerender();
  }

  getWordSearchProps(key?: keyof WordSearchProps) {
    if (key) {
      return this.wordSearchProps?.[key];
    } else {
      return { ...this.wordSearchProps };
    }
  }
}

export * from "./interfaces";
